import { render, staticRenderFns } from "./c_slider.vue?vue&type=template&id=35044b96&scoped=true&"
import script from "./c_slider.vue?vue&type=script&lang=js&"
export * from "./c_slider.vue?vue&type=script&lang=js&"
import style0 from "./c_slider.vue?vue&type=style&index=0&id=35044b96&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35044b96",
  null
  
)

export default component.exports